import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=4b59664c&scoped=true"
import script from "./TenantDetail.vue?vue&type=script&lang=js"
export * from "./TenantDetail.vue?vue&type=script&lang=js"
import style0 from "./TenantDetail.vue?vue&type=style&index=0&id=4b59664c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59664c",
  null
  
)

export default component.exports